$(function () {
    $(document).on('click', 'a[href^="#"]', function(e) {
        let offset = 130;
        e.preventDefault();
        let attr = $(this).attr('href');
        let target = $(document.getElementById(attr.replace('#', '')));
        if (!target.length) {
            return;
        }

        $('html, body').animate({
            scrollTop: target.offset().top - offset,
        }, 1000, 'swing');
    });

    window.scrollTo = function (targetName) {
        const target = $(targetName);
    
        if (!target.length) {
            return;
        }
    
        let offset = target.offset().top;
        offset -= $('header').outerHeight();
    
        $('html, body').animate({
            scrollTop: offset - 128,
        }, 1000);
    };
});
